export default "__VITE_ASSET__C99EFlrQ__"